import config from '../config';

export const getPublicReceiptUrl = (applicationId) => {
  const baseUrl = (config.RECEIPT_BASE_URL || window.location.origin).replace(/\/+$/, '');
  return `${baseUrl}/receipt/${encodeURIComponent(applicationId || '')}`;
};

export const getQrCodeDataUrl = (value) => new Promise((resolve) => {
  if (!value) {
    resolve(null);
    return;
  }

  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.referrerPolicy = 'no-referrer';
  img.src = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&margin=12&data=${encodeURIComponent(value)}`;
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth || 260;
    canvas.height = img.naturalHeight || 260;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    try {
      resolve(canvas.toDataURL('image/png'));
    } catch {
      resolve(null);
    }
  };
  img.onerror = () => resolve(null);
});
